import { Component, Input, inject } from '@angular/core';
import { UserGuideService } from '../user-guide.service';
import { PayeeIconComponent } from '../../shared/payee-icon/payee-icon.component';

@Component({
  selector: 'app-chapter',
  templateUrl: './chapter.component.html',
  styleUrls: ['./chapter.component.scss'],
  imports: [PayeeIconComponent],
})
export class ChapterComponent {
  userGuideService = inject(UserGuideService);

  @Input() chapterId: string = '1';
  @Input() chapterName: string = 'Give a name to this chapter';

  get headerWeight() {
    const parts = this.chapterId.split('.');
    return parts.length;
  }
}
